import React from "react";
import PropTypes from "prop-types";
import {Col, ControlLabel, FormGroup} from "react-bootstrap";
import Box from "../component/Box/Box";
import FormButtons from "../component/Form/FormButtons";
import Loading from "../component/Loading/Loading";
import DispositionService from "./DipositionService";
import Notify from "../services/Notify";
import Objects from "../utils/Objects";
import CheckboxWithLabel from "../component/Checkbox/CheckBoxWithLabel";

class DispositionForm extends React.Component {

  service = new DispositionService();

  constructor(props) {
    super(props);
    this.state = {};
    this.onChange = this.onChange.bind(this);
    this.filterItems = this.filterItems.bind(this);
  }

  componentWillMount() {
    const {match} = this.props;
    const id = match.params.id;
    if (id) {
      const state = this.state;
      state.loading = true;
      this.setState(state);
      this.service.findById(id).then(
          data => {this.setState(
              {
                loading: false,
                entity: data
              });
            this.lastAssetState = data.lastAssetState;
          },
          error => {
            const state = {loading: false};
            if (error.response.status === 404) {
              state.message = 'Entidade não encontrada!';
            } else {
              state.message = 'Erro inesperado!';
              Notify.error('Falha o buscar entidade!', error)
            }
            this.setState(state);
          }
      )
    }
  }

  submitForm() {
    const existingEntity = this.state.entity && this.state.entity.id;
    const entityVersion = this.state.entity? this.state.entity.version:null;

    const entity = {
      id: existingEntity,
      friendlyName: this.friendlyName.value.trim(),
      description: this.description.value,
      erpCode: this.erpCode.value,
      lastAssetState: this.lastAssetState,
      version: entityVersion      };
    this.setState({loading: true, message: 'Salvando...'});
    this.service.save(entity).then(
        () => {
          this.props.history.goBack();
          Notify.success('Disposição salva');
        },
        (error) => {
          Notify.error('Falha ao salvar disposição:', error);
          this.setState({loading: false, message: null});
        });
  }

  onChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.state.isIntegrated = value;
    this.setState(this.state);
  }

  render() {
    const {loading, entity, message} = this.state;
    if (loading) {
      return <Loading message={message}/>
    }
    if (message) {
      return <h2>{message}</h2>
    }

    return (
        <Box info>
          <form ref={form => (this.form = form)} onSubmit={event => {
            event.preventDefault();
            this.submitForm()
          }}>

            <FormGroup>
              <ControlLabel>Nome</ControlLabel>
              <input type="text" className="form-control" placeholder="Nome"
                     required
                     name="friendlyName"
                     ref={friendlyName => this.friendlyName = friendlyName}
                     defaultValue={entity && entity.friendlyName}/>
            </FormGroup>

            <FormGroup>
              <ControlLabel>Descrição</ControlLabel>
              <input type="text" className="form-control" name="description"
                     ref={value => this.description = value}
                     defaultValue={entity && entity.description}
              />
            </FormGroup>
            <ControlLabel>Código do ERP</ControlLabel>
            <input type="text" className="form-control" name="erpCode"
                   ref={erpCode => this.erpCode = erpCode}
                   defaultValue={entity && entity.erpCode}
            />
            <FormGroup>
              <CheckboxWithLabel
                  label="Ultimo estado"
                  defaultValue={entity && entity.lastAssetState}
                  setValue={e => this.lastAssetState = !this.lastAssetState}
              />
            </FormGroup>

            <FormButtons history={this.props.history}/>
          </form>
        </Box>);
  }

  filterItems(item) {
    const {entity} = this.state;
    return Objects.isNullOrUndefined(entity) ? true : item.id !== entity.id;
  }
}

DispositionForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default DispositionForm;



// WEBPACK FOOTER //
// ./src/disposition/DispositionForm.js